import React from 'react'

export function Title({ title, image }) {
    const [imgError, setImgError] = React.useState(false)

    const initials =
        title && title.length >= 2
            ? `${title[0]?.toUpperCase()}${title[1]?.toUpperCase()}`
            : 'QU'

    return (
        <div className="flex items-center gap-1">
            <span className="rounded-full w-11 h-11 bg-primary dark:bg-secondary overflow-hidden">
                <div className="flex items-center justify-center text-xl font-bold text-white w-11 h-11">
                    {image && !imgError ? (
                        <img
                            className="rounded-full w-11 h-11"
                            src={image}
                            alt={'logo'}
                            onError={() => setImgError(true)}
                        />
                    ) : (
                        initials
                    )}
                </div>
            </span>
            {title}
        </div>
    )
}

export function status(status, check = false) {
    let className = ''
    let name = ''
    switch (status) {
        case true:
            className = 'text-success bg-success'
            name = 'Active'
            break
        default:
            className = 'text-danger bg-danger'
            name = 'Inactive'
            break
    }
    if (check) return name
    return (
        <div
            className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}
        >
            {name}
        </div>
    )
}

export function verifyStatus(status, check = false) {
    let className = ''
    let name = ''
    switch (status) {
        case true:
            className = 'text-success bg-success'
            name = 'Verified'
            break
        default:
            className = 'text-danger bg-danger'
            name = 'Unverified'
            break
    }
    if (check) return name
    return (
        <div
            className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}
        >
            {name}
        </div>
    )
}

export function numberFormat(
    value,
    currency,
    digits = 2,
    style = 'currency', // decimal, currency, percent, unit
) {
    value = style === 'percent' ? value / 100 : value
    return new Intl.NumberFormat('en-US', {
        style: style,
        currency: currency ?? 'USD',
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
    }).format(value)
}

export function convertString(string) {
    if (typeof string === 'string') {
        let arr = string
            .toLowerCase()
            .split('-')
            .map((item) => item.charAt(0).toUpperCase() + item.substring(1))
        return arr.join(' ')
    }
}

export function convertToCSV(data) {
    if (!data.length) return ''

    const headers = Object.keys(data[0])
    const csvRows = [
        headers.join(','), // header row
        ...data.map((obj) =>
            headers.map((header) => `"${obj[header]}"`).join(','),
        ),
    ]

    return csvRows.join('\n')
}

export function getYesterdayDate() {
    const today = new Date()
    today.setDate(today.getDate() - 1)
    return today
}

export function getPagination(current, total, delta = 2) {
    const range = []
    const rangeWithDots = []
    let last

    for (let i = 1; i <= total; i++) {
        if (
            i === 1 ||
            i === total ||
            (i >= current - delta && i <= current + delta)
        ) {
            range.push(i)
        }
    }

    for (let i of range) {
        if (last) {
            if (i - last === 2) {
                rangeWithDots.push(last + 1)
            } else if (i - last > 2) {
                rangeWithDots.push('...')
            }
        }
        rangeWithDots.push(i)
        last = i
    }

    return ['Previous', ...rangeWithDots, 'Next']
}
